<template>
<!-- <div class="all" v-if="user.isAgent"> -->
  <div class="all">
    <div class="top-page">
      <router-link to="../" class="button">←　ヘルプページトップへ戻る</router-link>
 
    </div>
    <div class="tab_box">
      <ul class="tab_list">
        <li v-bind:class="{active:isActiveTab == 1}" @click="changeActive(1)">新規作成</li>
        <li v-bind:class="{active:isActiveTab == 2}" @click="changeActive(2)">　編集　</li>
      </ul>
      <div>
        <ul class="article">
          <li v-if="isActiveTab == 1">
            <div style="border:1px solid black; background-color:floralwhite;">
              <!-- プログレスバー -->
              <!-- step1 -->
              <div class="Group" v-if="progress == 1">
                <div class="Group-Bar"></div>
                <div class="Group-Item" :class="{isActiveNew:progress == 1}" @click="progressChange(1)">
                  <div class="Group-Item-CircleOuter Circle Shapeborder" :class="{isActiveNew:progress == 1}">
                    <div class="Group-Item-CircleInner Circle Shapeborder"  :class="{isActiveNew:progress == 1}"></div>
                  </div>
                  <p class="Group-Item-Text">1</p>
                </div>
                <div class="Group-Item"  :class="{isActiveNew:progress == 2}">
                  <div class="Group-Item-CircleOuter Circle Shapeborder" :class="{isActiveNew:progress == 2}">
                    <div class="Group-Item-CircleInner Circle Shapeborder"  :class="{isActiveNew:progress == 2}"></div>
                  </div>
                  <p class="Group-Item-Text">2</p>
                </div>
                <div class="Group-Item"  :class="{isActiveNew:progress == 3}">
                  <div class="Group-Item-CircleOuter Circle Shapeborder"  :class="{isActiveNew:progress == 3}">
                    <div class="Group-Item-CircleInner Circle Shapeborder"  :class="{isActiveNew:progress == 3}"></div>
                  </div>
                  <p class="Group-Item-Text">3</p>
                </div>
              </div>
              <!-- step2 -->
              <div class="Group" v-if="progress == 2">
                <div class="Group-Bar"></div>
                <div class="Group-Item" :class="{isActiveNew:progress == 1}" @click="progressChange(1)">
                  <div class="Group-Item-CircleOuter Circle Shapeborder" :class="{isActiveNew:progress == 1}">
                    <div class="Group-Item-CircleInner Circle Shapeborder"  :class="{isActiveNew:progress == 1}"></div>
                  </div>
                  <p class="Group-Item-Text">1</p>
                </div>
                <div class="Group-Item"  :class="{isActiveNew:progress == 2}" @click="progressChange(2)">
                  <div class="Group-Item-CircleOuter Circle Shapeborder" :class="{isActiveNew:progress == 2}">
                    <div class="Group-Item-CircleInner Circle Shapeborder"  :class="{isActiveNew:progress == 2}"></div>
                  </div>
                  <p class="Group-Item-Text">2</p>
                </div>
                <div class="Group-Item"  :class="{isActiveNew:progress == 3}">
                  <div class="Group-Item-CircleOuter Circle Shapeborder"  :class="{isActiveNew:progress == 3}">
                    <div class="Group-Item-CircleInner Circle Shapeborder"  :class="{isActiveNew:progress == 3}"></div>
                  </div>
                  <p class="Group-Item-Text">3</p>
                </div>
              </div>
              <!-- step3 -->
              <div class="Group" v-if="progress == 3">
                <div class="Group-Bar"></div>
                <div class="Group-Item" :class="{isActiveNew:progress == 1}" @click="progressChange(1)">
                  <div class="Group-Item-CircleOuter Circle Shapeborder" :class="{isActiveNew:progress == 1}">
                    <div class="Group-Item-CircleInner Circle Shapeborder"  :class="{isActiveNew:progress == 1}"></div>
                  </div>
                  <p class="Group-Item-Text">1</p>
                </div>
                <div class="Group-Item"  :class="{isActiveNew:progress == 2}" @click="progressChange(2)">
                  <div class="Group-Item-CircleOuter Circle Shapeborder" :class="{isActiveNew:progress == 2}">
                    <div class="Group-Item-CircleInner Circle Shapeborder"  :class="{isActiveNew:progress == 2}"></div>
                  </div>
                  <p class="Group-Item-Text">2</p>
                </div>
                <div class="Group-Item"  :class="{isActiveNew:progress == 3}" @click="progressChange(3)">
                  <div class="Group-Item-CircleOuter Circle Shapeborder"  :class="{isActiveNew:progress == 3}">
                    <div class="Group-Item-CircleInner Circle Shapeborder"  :class="{isActiveNew:progress == 3}"></div>
                  </div>
                  <p class="Group-Item-Text">3</p>
                </div>
              </div>

              <!-- body -->
              <!-- step1 -->
              <div class="step1" v-if="progress == 1">
                <h1 style="text-align:center; border-bottom: dotted 6px #323;">追加する項目を選択</h1>
                <div class="flex content-container-helpItem">
                  <div class="columns is-multiline is-mobile" style="justify-content: center;">
                    <span
                      v-for="(helpItem, index) in sortedHelpItemsBySort"
                      :key="index"
                      @mouseover="cbStatusHover=helpItem"
                    >
                      <div class="step1-card" style="margin: 10px;" @click="clickCard(helpItem.sort_id,helpItem.item_id)">
                        <div class="card-item" style="display: flex; justify-content: center; align-items: center;">
                          <h2>{{helpItem.item}}</h2>
                        </div>
                        <div class="card-contents" style="display: flex; justify-content: center; align-items: center;">
                          <figure class="img-icon">
                            <img :src="helpItem.image" v-if="helpItem.image!=''">
                            <img src="../../assets/template/human.png" v-if="helpItem.image==''">
                          </figure>
                        </div>
                        <div class="card-description" style="display: flex; justify-content: center; align-items: center; margin:20px;">
                          <h3>{{helpItem.description}}</h3>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>

              <!-- step2 -->
              <div class="step2" v-if="progress==2">
                <h1 style="text-align:center; border-bottom: dotted 6px #323;">追加する場所を選択</h1>
                <!--<b-loading :active="isLoading" :is-full-page="true"></b-loading> -->
                <div style="margin-top:50px;">
                  <ul>
                    <span
                      v-for="(help, index2) in sortedHelpsBySort"
                      :key="index2"
                      @mouseover="cbStatusHover=help"
                    >
                      <div style="text-align:center;">
                        <button class="plusButton" @click="clickPlus(index2+1)">+</button>
                      </div>
                      <div class="step2-card" @click="toggleShow(index2)">
                        <li style="border:none;">
                          <h4 v-if="!isShow[index2]">▶︎ {{help.question}}</h4>
                          <h4 v-if="isShow[index2]">▼ {{help.question}}</h4>
                          <!--<transition name="fade">-->
                            <!-- <p v-if="isShow[index2]">
                              {{help.answer}}<br>
                            </p> -->
                          <div v-if="isShow[index2]" id="preview" class="content ql-editor" v-html="help.answer"></div>
                          <p class="img-icon" v-if="isShow[index2]">
                            <img :src="help.image" v-if="help.image!=''">
                          </p>
                          <!--</transition>-->
                        </li>
                      </div>
                    </span>
                  </ul>
                  <div style="text-align:center;">
                    <button class="plusButton" @click="clickPlus(sortedHelpsBySort.length+1)">+</button><br>
                  </div>
                  <b-button size="lg" @click="progressChange(1)">戻る</b-button><br><br>
                </div>
              </div>

              <!-- step3 -->
              <div class="step3" v-if="progress == 3">
                <div class="head">
                  <b-field horizontal label="タイトル">
                    <b-input v-model="inputs.question" placeholder="タイトルを入力してください"  maxlength="20"></b-input>
                  </b-field>
                </div>
                <div class="left">
                  <quill-editor v-model="inputs.answer" ref="quillEditor" :options="editorOption" style="height:375px;"></quill-editor>
                </div>
                <div class="right">
                  <div id="preview" class="content ql-editor" v-html="inputs.answer"></div>
                </div>
                <div class="foot">
                  <b-button style="float:left; margin-left:20px;" size="lg" @click="progressChange(2)">戻る</b-button>
                  <button class="button is-primary" style="float:right; margin-right:20px;" @click="clickCreateHelp()"  v-bind:disabled="this.inputs.question=='' || this.inputs.answer=='' ">作成する</button>
                </div>
              </div>
            </div>
          </li>


          <li v-if="isActiveTab == 2">
            <div style="border:1px solid black; background-color:floralwhite;height:1200px;"><br><br>
              <div class="body-help">
                <div id="menu">
                  <button v-for="(helpItem, index) in sortedHelpItemsBySort"
                    :key="index"
                    class="button menu-card-small"
                    v-bind:class="{'menu-card-hover' : isActiveEdit == helpItem.item_id}" 
                    @click="toggleAction(helpItem.item_id)"
                  >
                    {{getSubString(helpItem.item, 16)}}
                  </button>      
                </div>
                <div class="qa">
                  <ul>
                    <div v-if="isDanger == true" class="box-text-notice">順番で重複している箇所があります。</div>
                    <span
                      v-for="(help, index2) in sortedHelpsByQA"
                      :key="index2"
                      @mouseover="cbStatusHover=help"
                    >
                      <div
                       style="border:double 5px red;"
                        class="qa-card"
                        @click="toggleShow(index2)"
                        v-bind:class="{show:isShow[index2],notshow:!isShow[index2]}"
                        v-if="isActiveEdit== help.item_id && getDuplication(help.item_id, help.sort_id) == true" 
                      >        
                        <li>
                          <h1 v-if="!isShow[index2]">▶︎ {{help.question}}</h1>
                          <h1 v-if="isShow[index2]">▼ {{help.question}}</h1>
                          <b-button class="button is-danger"  style="float:right;" @click="deleteButton(help.sort_id,help.help_id)">削除</b-button>
                          <b-button class="button" style="float:right; margin-right:10px;" @click="editButton(help)">編集</b-button>
                          <span style="float:right; margin-right:20px;" >順番：{{help.sort_id}}</span><br><br>
                          <div v-if="isShow[index2]" id="preview" class="content ql-editor" v-html="help.answer"></div>
                        </li>
                      </div>
                      <div
                        style="border:solid 1px black"
                        class="qa-card"
                        @click="toggleShow(index2)"
                        v-bind:class="{show:isShow[index2],notshow:!isShow[index2]}"
                        v-else-if="isActiveEdit== help.item_id" 
                      >        
                        <li>
                          <h1 v-if="!isShow[index2]">▶︎ {{help.question}}</h1>
                          <h1 v-if="isShow[index2]">▼ {{help.question}}</h1>
                          <b-button class="button is-danger"  style="float:right;" @click="deleteButton(help.sort_id,help.help_id)">削除</b-button>
                          <b-button class="button" style="float:right; margin-right:10px;" @click="editButton(help)">編集</b-button>
                          <span style="float:right; margin-right:20px;" >順番：{{help.sort_id}}</span><br><br>
                          <div v-if="isShow[index2]" id="preview" class="content ql-editor" v-html="help.answer"></div>
                        </li>
                      </div>
                    </span>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <!-- モーダル -->
      <b-modal :active.sync="quillModal" @close="quillModal=false">
        <div class="card" style="border-radius: 5px; width:1000px; display:inline-block;">
          <div class="card-content">
            <div class="modal-quill">
            <div class="head2">
              <b-field grouped style="width:1000px;">
              <b-field horizontal label="タイトル" expanded>　
                <b-input v-model="helpBody.question" placeholder="タイトルを入力してください"  maxlength="20"></b-input>
              </b-field>
              <b-field horizontal label="順番" expanded> 
                <b-input style="width:50px;" size="is-small" type="number" min="1" class="form-control"  v-model="helpBody.sort_id"></b-input>
              </b-field></b-field>

            </div>
            <div class="left2">
              <quill-editor v-model="helpBody.answer" ref="quillEditor" :options="editorOption" style="height:375px;"></quill-editor>
            </div>
            <div class="right2">
              <div id="preview" class="content ql-editor" v-html="helpBody.answer"></div>
            </div>
            <div class="foot2">
              <b-button style="float:left; margin-left:20px;" size="lg" @click="returnModal()">戻る</b-button>
              <button class="button is-danger" style="float:left; margin-left:5px;" @click="deleteButton(nowSort,helpBody.help_id)">削除する</button>
              <button class="button is-primary" style="float:right; margin-right:20px;" @click="updateHelp()"  v-bind:disabled="this.helpBody.question==this.nowQuestion && this.helpBody.answer==this.nowAnswer && this.helpBody.sort_id==this.nowSort">更新する</button>
              <button class="button " style="float:right; margin-right:20px;" @click="undo()" v-bind:disabled="this.helpBody.question==this.nowQuestion && this.helpBody.answer==this.nowAnswer && this.helpBody.sort_id==this.nowSort">元に戻す</button>

            </div>
          </div>
        </div>
        </div>
      </b-modal>
          

      <!-- 作成 -->
      <b-modal :active.sync="isModal" @close="isModal=false">   
        <div class="card" style="border-radius: 5px; width:500px; display:inline-block;">
          <div class="card-content">
            <p>
              <b-message type="is-info" has-icon>
                作成されました
              </b-message>
            </p>
          </div>
          <footer class="card-footer">
            <a class="card-footer-item" @click="isOK()">OK</a>
          </footer>
        </div>
      </b-modal>

      <!-- 更新 -->
      <b-modal :active.sync="isUpdateModal" @close="isUpdateModal=false">   
        <div class="card" style="border-radius: 5px; width:500px; display:inline-block;">
          <div class="card-content">
            <p>
              <b-message type="is-info" has-icon>
                更新されました
              </b-message>
            </p>
          </div>
          <footer class="card-footer">
            <a class="card-footer-item" @click="isOK()">OK</a>
          </footer>
        </div>
      </b-modal>

      <!-- 削除 -->
    <b-modal :active.sync="isDelete" @close="isDelete=false">
      <div class="card" style="border-radius: 5px; width:600px; display:inline-block;" v-if="getConfirmation">
        <div class="card-content">
          <p>
            <b-message type="is-danger" has-icon>
              本当に削除してもよろしいですか。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="noDelete()">いいえ</a>
          <a class="card-footer-item" @click="deleteHelp()">はい</a>
        </footer>
      </div>
      <div class="card" style="border-radius: 5px;  width:500px; display:inline-block;" v-if="!getConfirmation">
        <div class="card-content">
          <p>
            <b-message type="is-info" has-icon>
              削除しました。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="successDelete()">OK</a>
        </footer>
      </div>
    </b-modal>

    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(VueQuillEditor);

export default {
  name: "CategoryHelpInputBody",
  computed: {
    ...mapState("help", ["helps", "helpItems", "isLoading"]),
    ...mapState("auth", ["user"]),
    sortedHelpItemsBySort() {
      console.debug('*** Start *** sortedHelpItemsBySort')
      return this.helpItems.sort((a, b) => {
        return a.sort_id < b.sort_id ? -1 : a.sort_id > b.sort_id ? 1 : 0;
      });
    },
    sortedHelpsBySort() {
      console.debug('*** Start *** sortedHelpsBySort')
      return this.sortBox.sort((a, b) => {
        return a.sort_id < b.sort_id ? -1 : a.sort_id > b.sort_id ? 1 : 0;
      });
    },
    sortedHelpsBySortDuplication() {
      console.debug('*** Start *** sortedHelpsBySort')
      return this.helps.sort((a, b) => {
        return a.sort_id < b.sort_id ? -1 : a.sort_id > b.sort_id ? 1 : 0;
      });
    },
    sortedHelpsByQA() {
      console.debug('*** Start *** sortedHelpsByQA')
      return this.QAbox.sort((a, b) => {
        return a.sort_id < b.sort_id ? -1 : a.sort_id > b.sort_id ? 1 : 0;
      });
      },
  },
  data() {
    return {
      sortBox:[],
      createBox:[],
      QAbox:[],
      progress:1,
      isActiveNew:0,
      isActiveEdit:0,
      isActiveTab:1,
      isShow: [],
      editorOption: {
        theme: "snow"
      },
      inputs: {
        question:'',
        answer:'',
      },
      isModal : false,
      isUpdateModal: false,
      isDeleteId:"",
      isDelete:false,
      isSort:"",
      getConfirmation:true,
      quillModal:false,
      helpBody:{},
      nowQuestion:"",
      nowAnswer:"",
      nowSort:"",
      isDanger:false,
      DuplicationSort:[],
    };
  },
  mounted() {
    console.log('*** Start *** mounted')
    this.$store.dispatch("help/getHelp")
    this.DuplicationSort=[]
    var sortBox=[]
    setTimeout(() => {this.$store.dispatch("help/getHelp")}, 500)
    setTimeout(() => {this.$store.dispatch("help/getHelpItem")}, 500) 
    setTimeout(() => {
      for(var i in this.sortedHelpsBySortDuplication){
        sortBox.push(this.sortedHelpsBySortDuplication[i].item_id + '/' + this.sortedHelpsBySortDuplication[i].sort_id)
      }
      this.DuplicationSort = sortBox.filter(function (x, i, self) {
          return self.indexOf(x) === i && i !== self.lastIndexOf(x);
      });
    }, 1000)
    console.log('*** End *** mounted')
  },
  methods: {
    // 文字省略
    getSubString (m, num) {
      if (m) {
        return m.length < num ? m : m.substring(0, num - 3) + '...'
      } else {
        return 'no title'
      }
    },
    getText(){
      this.$store.dispatch("help/getHelpItem");
      this.$store.dispatch("help/getHelp");
      this.QAbox=[]

        var sort_number = 0
        for(var i in this.helps){
          if(this.helps[i].sort_id == sort_number){
            this.isDanger = true
          }
          sort_number = this.helps[i].sort_id
        }
      for(var i in this.helps){
        if(this.helps[i].item_id == this.isActiveEdit){
          this.QAbox.push(this.helps[i])
        }
      }

      
    },
    // タブ切り替え
    changeActive(number){
      this.isActiveTab = number
      this.inputs.image = ""
    },
    // 進捗
    progressChange(number){
      this.$store.dispatch("help/getHelp");
      this.progress = number
      this.inputs.question = ""
      this.inputs.answer = ""
    },
    // STEP1
    clickCard(id,item_id){
      this.sortBox = []
      this.createBox = []
      this.$store.dispatch("help/getHelp");
      this.inputs.item_id = item_id
      this.progress = 2
      this.isActiveNew = Number(id)
      for (let i=0; i < this.helps.length; i++){
        if (this.helps[i].item_id == item_id){
            this.sortBox.push(this.helps[i])
        }
      }
    },
    // STEP2
    clickPlus(number){
      this.inputs.sort_id = number
      this.progress = 3
      for (let i=0; i < this.helps.length; i++){
        if (this.helps[i].item_id == this.inputs.item_id && this.helps[i].sort_id >= this.inputs.sort_id){
            this.createBox.push(this.helps[i])
        }
      }
    },
    // STEP3 作成
    clickCreateHelp() {
      console.debug('*** Start *** clickCreateHelp')
      console.log("clickCreateHelp: " + this.inputs.question);
      this.isModal = true
      this.$store.dispatch("help/createHelp", { data: this.inputs });
      for (let i=0; i < this.createBox.length; i++){
        this.$store.dispatch("help/updateHelp", { data: this.createBox[i] })
      }
      console.debug('*** End *** clickCreateHelp')
    },
    // 編集左側
    toggleAction(index){
      this.isDanger = false
      this.QAbox=[]
      console.debug('*** Start *** toggleAction')
      console.debug('index: ' + JSON.stringify(index))
      //this.$store.dispatch('help/tabLoading');
      this.isActiveEdit = index
      for(var i in this.helps){
        if(this.helps[i].item_id == index){
          this.QAbox.push(this.helps[i])
        }
      }
      console.debug('*** End *** toggleAction')
    },
    // 編集右側
    toggleShow: function(index2) {
      console.debug('*** Start *** toggleShow')
      console.debug('index2: ' + JSON.stringify(index2))
      this.$set(this.isShow, index2, !this.isShow[index2]);
      console.debug('*** End *** toggleShow')
    },
    // 削除しますか→はい
    deleteHelp(){
      this.$store.dispatch('help/deleteHelp',
      {
        'help_id':this.isDeleteId
      })
      for (var i in this.helps){
        if (this.isActiveNew == this.helps[i].item_id && this.helps[i].sort_id > this.isSort){
          this.$store.dispatch("help/updateHelp",
            {
              'help_id':this.helps[i].help_id,
              'sort_id':String(Number(this.help[i].sort_id) - 1)
            })
          }
        }
      setTimeout(() => {
        this.getText()
      }, 1000)
      this.isDeleteId=""
      this.getConfirmation = false
    },
    // 本当に削除してもよろしいですか
    deleteButton(sort, id){
      this.isSort = sort
      this.isDeleteId=id
      this.isDelete=true
    },
    // 削除しますか→いいえ
    noDelete(){
      console.debug('*** Start *** deleteChatBot')
      this.createBox=[]
      this.isDelete=false
      this.isDeleteId=""
      this.isSort=""
      this.getConfirmation = true
      console.debug('*** End *** deleteChatBot')
    },
    // 削除しました
    successDelete(){
      this.isSort = ""
      this.isDeleteId = ""
      this.isDelete=false
      this.quillModal = false
      setTimeout(() => {
        this.getText()
      }, 1000)

    },
    // 作成/更新しました
    isOK(){
      this.isModal = false
      this.isUpdateModal = false
      this.progress = 1
      this.inputs.question = ""
      this.inputs.answer = ""
      this.quillModal = false
      setTimeout(() => {
        this.getText()
      }, 1000)

    },
    // 更新
    updateHelp(){
      this.$store.dispatch("help/updateHelp", { data: this.helpBody })    
      this.isUpdateModal = true
      setTimeout(() => {
        this.getText()
      }, 1000)
    },
    // 編集ボタン 
    editButton(help){
      this.quillModal = true
      this.helpBody=help
      this.nowQuestion=help.question
      this.nowAnswer=help.answer
      this.nowSort=help.sort_id
    },
    // 元に戻す
    undo(){
      this.helpBody.question = this.nowQuestion
      this.helpBody.answer = this.nowAnswer
      this.helpBody.sort_id = this.nowSort
    },
    // 戻る
    returnModal(){
      this.quillModal=false
      this.helpBody.question = this.nowQuestion
      this.helpBody.answer = this.nowAnswer
      this.helpBody.sort_id = this.nowSort
    },
    // 重複確認
    getDuplication(id, sort){
      for(var i in this.DuplicationSort){
        if(this.DuplicationSort[i] == id + "/" + sort){
          this.isDanger = true
          return true
        }
      }
    }
  }
};
</script>

<style scoped>
/* タブ */
.tab_box{
  padding-top:50px;
}
.tab_list {
  overflow: hidden;
   margin-left: 10%;
}
.tab_list li {
  float: left;
  padding: 10px 100px;
  border: 1px solid #ccc;
  border-bottom: none;
  cursor: pointer;
  transition: .3s;
  border-radius: 15px 15px 0px 0px / 15px 15px 0px 0px;
}
.tab_list li.active {
  background-color: floralwhite;
  border-color: #000;
  color: #000;
  cursor: auto;
}
.article{
  overflow: hidden;
  margin-top: -1px;
}
.article li {
  width: 90%;
  margin:0px auto;
  padding: auto;
  border: 1px solid #ccc;
}

/* プログレスバー */
.Group {
  margin: 30px auto 24px;
  position: relative;
  width: 100%;
  max-width: 320px;
  display: flex;
  justify-content: space-between;
  z-index: 0; 
}
.Group-Bar {
  position: absolute;
  top: 12px;
  left: 5%;
  width: 90%;
  height: 2px;
  background-color: #eaeaea;/*バーの色*/
  z-index: -1;
}
@media screen and (min-width: 768px) {
  .Group-Bar {
    top: 17px;
    height: 5px;
  }
}
.Shapeborder.isActiveNew {
  border: 1px solid #e2264d;
}
.Circle {
  border-radius: 50%;
}
.Group-Item {
  color: #b7b7b7;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Group-Item.isActiveNew {
  color: #e2264d;
}
.Group-Item-CircleOuter {
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (min-width: 768px) {
  .Group-Item-CircleOuter {
    width: 39px;
    height: 39px;
  }
}
.Group-Item-CircleOuter.isActiveNew {
  background: #fff;
}
.Group-Item-CircleInner {
  width: 16px;
  height: 16px;
  background-color: #b7b7b7;
  display: flex;
  align-items: center;
}
@media screen and (min-width: 768px) {
  .Group-Item-CircleInner {
    width: 25px;
    height: 25px;
  }
}
.Group-Item-CircleInner.isActiveNew {
  background: #e2264d;
}
.Group-Item-CircleInner:last-of-type::after {
  content: none;
}
.Group-Item-Text {
  margin-top: 10px;
  font-size: 1.4rem;
  font-weight: 600;
}

/* step1 */
.step1{
  width:90%;
  margin: 0 auto;
}
.step1 h1{
  font-weight: 700;
  font-size: 35px;
  margin: 10px 15px 10px 45px;
  padding: 10px;
}
.step1 h2 {
  display: block;
  font-size: 1.5em;
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}
.step1-card {
  border-radius: 5px;
  max-width: 400px;
  min-width: 400px;
  max-height: 380px;
  min-height: 380px;
  cursor: pointer;
  border:solid 3px #d3d1d1;

}
.step1-card:hover {
  background: #d3d1d1;
  transform: scale(1.1);
  transition: 0.2s;
}
.img-icon > img {
  display: block;
  min-width: 128px;
  min-height: 128px;
  width: 128px;
  height: 128px;
  max-width: 128px;
  max-height: 128px;
  border-radius: 50%;
}
.img-icon {
  width: 100%-20px;
} 

/* step2 */
.step2 {
  /* background-color: #f2f2f2; */
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.step2 p {
  margin: 10px 50px;
  padding: 10px;
}
.step2 h1 {
  font-weight: 700;
  font-size: 35px;
  margin: 10px 15px 10px 15px;
  padding: 10px;
}
.step2 h4{
  font-weight: 500;
  font-size: 20px;
  margin: 2px 0;
  /* padding: 10px; */
  color:#a9a9a9;
}
.step2-card {
  /* background-color: #f2f2f2; */
  margin: 15px auto;
  min-height: 0;
  min-width: 0;
  border-radius: 5px;
  max-width: 80%;
  min-width: 80%;
  cursor: pointer;
  border:solid #d3d3d3;
  border-width: 0.5px;
}
.step2-card.notshow h1:hover {
  color: #96a8af;
}

.plusButton{
  height:40px;
  width:40px;
  background-color: #fff;
  border: 2px solid #000;
  color: #000;
  border-radius: 5px;
  font-size:25px;
  padding-bottom:5px;
}
.plusButton:hover {
  background-color: #E53787;
  color: #fff;
}

/* step3 */
.step3 {
  width:90%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: 70px 500px 100px;
  grid-template-areas: "head head" "left right" "foot foot";
}
.head {
  grid-area: head;
  padding: 0px 200px 0px 100px;
}
.foot {
  grid-area: foot;
  padding-top:10px;
}
.left { 
  grid-area: left;
  /* background-color: black; */
  padding:10px;
  margin:0 0 0 10px;
  border:solid black;
}
.right { 
  grid-area: right;
  padding:10px;
  margin:0 10px 0 0;
  border:solid black;
  border-left: none;
  overflow-y: scroll;
}
.right::-webkit-scrollbar {
  width: 10px;
}
.right::-webkit-scrollbar-thumb {
  background: #E53787;
}
.right::-webkit-scrollbar-track-piece:start {
  border-radius: 10px;
  background: silver;
}
.right::-webkit-scrollbar-track-piece:end {
  border-radius: 10px;
  background: silver;
}

/* quilleditor */
#editor {
  height: 250px;
}
#editor .quill-editor {
  height: 100%;
}
#editor .quill-editor .ql-container {
  height: 60%;
}
#preview {
  padding: 15px;
}
#preview h1 {
  display: block;
  font-size: 2em;
  margin-block-start: 0.67em;
  margin-block-end: 0.67em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}

.flex {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}

.content-container-helpItem {
  overflow-y: scroll;
  overflow-x: hidden;
  padding-top: 50px;
  width: 100%;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  height: 100vh;
  padding-bottom: 220px;
}

.card-header {
  height: 95px;
  padding: 7%;
}

.card-contents {
  padding: 0 0 0 0;
}

.card-item {
  min-height: 120px;
  max-height: 120px;
  padding: 20px;
}

a:link {
  color: #000000;
}
a:visited {
  color: #000000;
}
a:hover {
  color: #000000;
}
a:active {
  color: #000000;
}

/*上部ボタン*/
.top-page{
  float:left;
  margin-left:5%;
}
.all{
  margin-top:40px;
}

/*左側メニュー*/
#menu {
  display: block;
  float: left;
  width: 25%;
  height:1000px;
  overflow-y: scroll;
}
#menu::-webkit-scrollbar {
  width: 10px;
}
#menu::-webkit-scrollbar-thumb {
  background: #E53787;
}
#menu::-webkit-scrollbar-track-piece:start {
  border-radius: 10px;
  background: silver;
}
#menu::-webkit-scrollbar-track-piece:end {
  border-radius: 10px;
  background: silver;
}

/*右側Q&A*/
.qa {
  width: 75%;
  /* padding: 50px 60px 60px 30px; */
  text-align: left;
  float: right;
  max-height:1000px;
  overflow-y: scroll;
}
.qa::-webkit-scrollbar {
  width: 10px;
}
.qa::-webkit-scrollbar-thumb {
  background: #E53787;
}
.qa::-webkit-scrollbar-track-piece:start {
  border-radius: 10px;
  background: silver;
}
.qa::-webkit-scrollbar-track-piece:end {
  border-radius: 10px;
  background: silver;
}
.qa p {
  margin: 10px;
  padding: 10px;
  margin-top:20px;
}
.qa h1 {
  font-weight: 700;
  font-size: 35px;
  margin: 10px 0 0;
  padding: 10px; 
}
.qa li{
  border:none;
}
.qa-card {
  background-color: #ffffff;
  margin: 15px 40px 15px 30px;
  min-height: 0;
  min-width: 0;
  border-radius: 5px;
  max-width: 95%;
  min-width: 95%;
  cursor: pointer;
  max-height:1000px;
  overflow-y: scroll;
}
.qa-card.show::-webkit-scrollbar {
  width: 10px;
}
.qa-card.show::-webkit-scrollbar-thumb {
  background: #E53787;
}
.qa-card.show::-webkit-scrollbar-track-piece:start {
  border-radius: 10px;
  background: silver;
}
.qa-card.show::-webkit-scrollbar-track-piece:end {
  border-radius: 10px;
  background: silver;
}
.qa-card.notshow{
  padding-right:10px;
}
.qa-card.notshow h1:hover {
  color: #96a8af;
}

/*編集左側*/
.menu-card-small {
  font-size:16px;
  color:black;
  background-color: white;
  margin-top:5px;
  margin-bottom:5px;
  height: 100px;
  width: 75%;
  border: solid #000000;
  position:relative;
  text-align: left;
}
.menu-card-small:hover {
  background-color: rgb(240, 167, 184);
  color: white;
}
.menu-card-small a {
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}
.menu-card-small a:link {
  color: black;
}
.menu-card-small a:visited {
  color: black;
}
.menu-card-small a:hover {
  color: black;
}
.menu-card-small a:active {
  color: black;
}
.menu-card-hover{
  background-color: #E53860;
  color: white;
  position:relative;
}
.menu-card-hover:hover{
  background-color: #E53860;
  color: white;
  cursor:auto;
}
.menu-card-hover a {
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}
.menu-card-hover a:link {
  color: white;
}
.menu-card-hover a:visited {
  color: white;
}
.menu-card-hover a:hover {
  color: white;
}
.menu-card-hover a:active {
  color: white;
}

/*編集モーダル*/
.modal-quill {
  width:100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: 70px 525px 40px;
  grid-template-areas: "head2 head2" "left2 right2" "foot2 foot2";
}
.head2 {
  grid-area: head2;
  padding: 0px 200px 0px 100px;
}
.foot2 {
  grid-area: foot2;
  padding-top:10px;
}
.left2 { 
  grid-area: left2;
  /* background-color: black; */
  padding:10px;
  margin:0 0 0 10px;
  border:solid black;
}
.right2 { 
  grid-area: right2;
  padding:10px;
  margin:0 10px 0 0;
  border:solid black;
  border-left: none;
  overflow-y: scroll;
}
.right2::-webkit-scrollbar {
  width: 10px;
}
.right2::-webkit-scrollbar-thumb {
  background: #E53787;
}
.right2::-webkit-scrollbar-track-piece:start {
  border-radius: 10px;
  background: silver;
}
.right2::-webkit-scrollbar-track-piece:end {
  border-radius: 10px;
  background: silver;
}

/*警告囲み枠*/
.box-text-notice {
    width:80%;
    position: relative;
    border: 3px double #da4033;
    border-radius: 5px;
    margin: 20px auto;
    padding: 20px 20px 5px 20px;
    font-size: 20px;
    text-align:center;
}
.box-text-notice::before {
    content: "重要！";
    position: absolute;
    background-color: floralwhite;
    color: #da4033;
    font-weight: bold;
    left: 20px;
    top: -33px;
    padding: 10px;
    font-size: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/Help/CategoryHelpInputBody.vue